import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../../../components/buttons/buttons";
import Input from "../../../../../components/inputs/inputs";
import { Beat } from "../../../../../plugins/spinners.plugin";
import Warning from "../../../../../assets/images/icons/warning.svg";
import {
  getOutletFromCookies,
  getOutletTypeFromCookies,
} from "../../../../../utils/Auth";
import { logoutUserLocallyAction } from "../../../../../redux/auth/unAuthActions";
import { transferRestaurantAction } from "../../../../../redux/restaurant/restaurantActions";
import { transferStore } from "../../../../../redux/stores/storeActions";

export default function TransferOutletOwnership() {
  const dispatch = useDispatch();
  const outlet = getOutletFromCookies();
  const outletType = getOutletTypeFromCookies();

  const [businessId, setBusinessId] = useState("");

  const { transferringRestaurant } = useSelector((state) => state.restaurant);
  const { transferringStore } = useSelector((state) => state.store);

  const handleTransferRestaurant = async () => {
    await dispatch(
      transferRestaurantAction({
        id: outlet?.id,
        business_id: businessId,
      })
    );
    dispatch(logoutUserLocallyAction());
  };

  const handleTransferStore = async () => {
    await dispatch(
      transferStore({
        id: outlet?.id,
        business_id: businessId,
      })
    );
    dispatch(logoutUserLocallyAction());
  };

  return (
    <div className="flex justify-center items-center mx-auto">
      <div>
        <div className="sm:max-w-[630px] w-full sm:border dark:border-none px-6 pb-16 bg-white dark:bg-[#121212] sm:border-gray-200 ">
          <div className="border-b-2 py-4 mb-6 flex justify-center ">
            <p className="text-base text-center sm:mt-6 font-bold text-gray-800 dark:text-white">
              Transfer Ownership
            </p>
          </div>

          <div className="my-5 px-3 py-4 flex gap-4 items-center border border-primary">
            <img
              src={Warning}
              alt="warning"
              className="w-[18px] h-[18px] cursor-pointer"
            />
            <p className="text-sm text-[#333333] dark:text-[#BCBCBC] font-medium">
              Caution: Once ownership is transferred, this action cannot be
              undone. Verify all details before confirming. You’ll be
              automatically logged out after the transfer is completed.
            </p>
          </div>

          <form>
            <div className="mt-4">
              <Input.Label
                title={"Enter Business ID"}
                htmlFor="businessId"
                name="businessId"
                placeholder="Enter Business ID"
                onChange={(e) => setBusinessId(e.target.value)}
              />
            </div>
          </form>
        </div>
        {/* Transfer Ownership buttons for store and restaurant for web view */}
        <div className="hidden sm:flex justify-center mt-6">
          {outletType === "restaurant" && (
            <Button.Primary
              type={"button"}
              disabled={transferringRestaurant || businessId === ""}
              onClick={() => handleTransferRestaurant()}
              title={transferringRestaurant ? <Beat /> : "Transfer Ownership"}
            />
          )}
          {outletType === "store" && (
            <Button.Primary
              type={"button"}
              disabled={transferringStore || businessId === ""}
              onClick={() => handleTransferStore()}
              title={transferringStore ? <Beat /> : "Transfer Ownership"}
            />
          )}
        </div>
      </div>
    </div>
  );
}
